"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _keys = require("./keys");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeRequest = function makeRequest(urlEndpoint, apiKey, data) {
  var options = {
    headers: {
      "x-api-key": apiKey,
      "Content-Type": "application/json"
    }
  };
  return _axios.default.post(urlEndpoint, data, options).then(function (response) {
    if (response) {
      return response.data;
    }
  }).catch(function (error) {
    return "FAIL";
  });
};

var submitZendesk = function submitZendesk(data) {
  var urlEndpoint = _keys.url + "/p/brand_contact";
  return makeRequest(urlEndpoint, _keys.apiKey, data);
};

var _default = submitZendesk;
exports.default = _default;